import { Modal, ModalBody, ModalContent, useDisclosure } from '@nextui-org/react'
import { FC } from 'react'
import { MdArrowForward, MdVisibility } from 'react-icons/md'
import { Button } from '@/components/ui/button'
import StepFlowView from '@/pages/backoffice/TradeInPage/components/StepFlowView'
import { TradeinProvider } from '@/pages/backoffice/TradeInPage/context/TradeinContext'
import { JoyRideProvider } from '@/pages/backoffice/TradeInPage/context/JoyRideContext'
import { STATUS_GROUPS } from '@/utils/tradeinStatusGroups'

interface TradeInProgressModalProps {
  tradeinId: number | string
  statusId: number
}

const TradeInProgressModal: FC<TradeInProgressModalProps> = ({ tradeinId, statusId }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure()
  // Entregado, No Aprobado, Retirado Reuse, Rechazado, Custodia, En Bodega: estados terminales,
  // ya no hay nada pendiente que avanzar (mismo set que el KPI "Finalizados" del Home).
  const finalizado = STATUS_GROUPS.finalizados.includes(statusId)

  return (
    <>
      <Button size='sm' variant={finalizado ? 'outline' : 'default'} onClick={onOpen}>
        {finalizado ? <MdVisibility /> : <MdArrowForward />}
        {finalizado ? 'Ver detalle' : 'Continuar'}
      </Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size='4xl' scrollBehavior='inside' placement='center' backdrop='blur'>
        <ModalContent className='h-[700px]'>
          <ModalBody className='py-6'>
            {isOpen && (
              <TradeinProvider idProps={tradeinId}>
                <JoyRideProvider disabled>
                  <StepFlowView />
                </JoyRideProvider>
              </TradeinProvider>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default TradeInProgressModal
